module.exports = __webpack_public_path__ + "img/ai-icon.9b14b0d3.png";